import 'prop-types';
import 'react';
import { jsx } from '@emotion/core';
import { ButtonToolbar, ButtonGroup, Button, Icon } from '@appfolio/react-gears';
import { observer } from 'mobx-react';
import _css from '@emotion/css';

var ContextMenu = function ContextMenu(_ref) {
  var pageStore = _ref.pageStore;
  if (!pageStore.contextMenu) return null;
  var copyDisabled = !pageStore.pdfStore.selectedField || !pageStore.contextMenu.onField;
  var pasteDisabled = !pageStore.pdfStore.copiedField;
  var showDeleteButton = pageStore.pdfStore.selectedField && pageStore.contextMenu.onField;

  var handleCopy = function handleCopy() {
    pageStore.pdfStore.setCopiedField(pageStore.pdfStore.selectedField);
    pageStore.pdfStore.setContextMenu();
  };

  var handlePaste = function handlePaste() {
    var _pageStore$contextMen;

    pageStore.pasteField((_pageStore$contextMen = pageStore.contextMenu) === null || _pageStore$contextMen === void 0 ? void 0 : _pageStore$contextMen.position);
  };

  var handleDelete = function handleDelete() {
    pageStore.deleteField(pageStore.pdfStore.selectedField);
    pageStore.pdfStore.setContextMenu();
    pageStore.pdfStore.setSelectedField();
  };

  var menuWidth = 81;
  var xPosition = pageStore.contextMenu.position.x;

  if (pageStore.unScale(xPosition + menuWidth) > pageStore.width) {
    xPosition -= menuWidth;
  }

  var menuHeight = showDeleteButton ? 91 : 61;
  var yPosition = pageStore.contextMenu.position.y;

  if (pageStore.unScale(yPosition + menuHeight) > pageStore.height) {
    yPosition -= menuHeight;
  }

  return jsx(ButtonToolbar, {
    className: "m-0",
    css:
    /*#__PURE__*/
    _css({
      position: 'absolute',
      width: menuWidth,
      height: menuHeight,
      left: "".concat(xPosition, "px"),
      top: "".concat(yPosition, "px")
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  }, jsx(ButtonGroup, {
    vertical: true
  }, jsx(Button, {
    onClick: handleCopy,
    disabled: copyDisabled
  }, jsx(Icon, {
    name: "clone",
    className: "mr-2"
  }), "Copy"), jsx(Button, {
    onClick: handlePaste,
    disabled: pasteDisabled
  }, jsx(Icon, {
    name: "clipboard",
    className: "mr-2"
  }), "Paste"), showDeleteButton && jsx(Button, {
    onClick: handleDelete
  }, jsx(Icon, {
    name: "times",
    className: "mr-2"
  }), "Delete")));
};

ContextMenu.displayName = "ContextMenu";
var ContextMenu$1 = observer(ContextMenu);
export default ContextMenu$1;